import React, { useState,useEffect } from 'react';
import { connect } from 'react-redux';
import { Col, Row, Card, Button, Input } from 'reactstrap';
import ReactQuill from 'react-quill';
import { Editor } from '../../../../../../../../Utils/Constants';
import ReactTable from "react-table";
import LoadingOverlay from "react-loading-overlay";
import Loader from "react-loaders";
import CustomModal from '../../../../../../../Components/Modals/CustomModal';
import CommentIcon from '../../../../../../../../designUtils/ProjectDashboard/CommentIcon.svg';
import AssetsCommentsPopup from '../AssetAnnotations/AssetsCommentsPopup';
import AddSubmissionsChatService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/AddSubmissionsChatService';
import FetchSubmissionsChatsService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/FetchSubmissionsChatsService';
import SendAssetsApprovalPopup from './SendAssetsApprovalPopup';

function GraphicsSubmission(props) {

    const [imageSearchText, setImageSearchText] = useState('');
    const [selectedImages, setSelectedImages] = useState([]);
    const [selectAllImages, setSelectAllImages] = useState(false);
    const [selectedFileObject, setSelectedFileObject] = useState({});
    const [noteList, setNoteList] = useState([]);
    const [sumbmissionNote, setSubmissionNote] = useState([]);
    const [demoImage, setDemoImage] = useState()
    const [comment, setComment] = useState('');
    const [isCommentsPopUpOPen, setIsCommentsPopUpOPen] = useState(false);
    const [loadScreen, setLoadScreen] = useState(false);
    const [filePath, setFilePath] = useState('');
    const [confrimationForSubmition,setConfrimationForSubmition] = useState(false);
    const [filteredImages, setFilteredImages] = useState([]);

    useEffect(() => {
        const filtered = getFilteredImageFiles(props.fileList, props.selectedASIN);
        setFilteredImages(filtered);
      }, [props.selectedASIN, props.fileList]);
      
      const getFilteredImageFiles = (fileList, selectedASIN) => {
        const imageExtensions = ['jpg', 'jpeg', 'png'];
      
        return (fileList || []).filter(file => {
          const isImage = file.fileType && imageExtensions.includes(file.fileType.split("/").pop().toLowerCase());
          if (!isImage) {
            return false;
          }
          const fileAsins = (typeof file.asinList === 'string' && file.asinList.trim() !== '') 
            ? file.asinList.split(',').map(a => a.trim().toUpperCase()).filter(Boolean) 
            : [];
          if (selectedASIN === "Unmapped Assets") {
            const isOthers = fileAsins.length === 0;
            return isOthers;
          }
          const normalizedSelectedASIN = selectedASIN ? selectedASIN.toUpperCase() : '';
          const isMatch = fileAsins.includes(normalizedSelectedASIN);
          return isMatch;
        });
      };

    const handleQuillChange = (value) => {
        setSubmissionNote(value)
    };

    const addSubmissionsChats = () => {
        const data = {
            notes: comment,
            assetId: selectedFileObject.id,
        };
        AddSubmissionsChatService(props.token, data).then((res) => {
            if (res) {
                setNoteList(res.noteList);
                setComment('');
            }
        });
    };

    const submissionsChats = (file) => {
        let data = {
            assetId: file.id
        }
        setSelectedFileObject(file);
        setLoadScreen(true);
        FetchSubmissionsChatsService(props.token, data).then((res) => {
            console.log(res)
            setNoteList(res);
            setLoadScreen(false);
        })
        setIsCommentsPopUpOPen(true);
        showNote(file.fileName, file.filePath)
    };

    const showNote = (path, fullPath) => {
        console.log(path);
        const ext = path.split(".")[1];
        if (ext == "xlsx" || ext == "csv" || ext == "xls" || ext == "docx" || ext == "doc" || ext == 'xlsm') {
            setDemoImage(true)
        } else {
            setFilePath(fullPath);
            setDemoImage(false)
        }
    };

    const searchedImages = filteredImages.filter(file =>
        file.actualFileName.toLowerCase().includes(imageSearchText.toLowerCase()) ||
        String(file.id).includes(imageSearchText)
      );
      
    const handleImageCheckboxChange = (id) => {
        setSelectedImages(prev =>
            prev.includes(id) ? prev.filter(imgId => imgId !== id) : [...prev, id]
        );
    };
    const handleSelectAllImages = () => {
        const newSelectAll = !selectAllImages;
        setSelectAllImages(newSelectAll);
        if (newSelectAll) {
            const allImageIds = filteredImages.map(img => img.id);
            setSelectedImages(allImageIds);
        } else {
            setSelectedImages([]);
        }
    };

    const handleSubmissionSuccess = (res) => {
      props.setSubmissionInnerCount(res.innerCountsOfSubmission);
      props.setFileList(res.fileList.fileList);
      props.setSubmissionList(res.submissionList.submissionList);
      setSelectedImages([]);
      setSelectAllImages(false);
      setConfrimationForSubmition(false);

      if (res.fileList.asinAssetsCount) {
        if (props.selectedASIN === 'Unmapped Assets') {
          props.setUnmappedCount(res.fileList.asinAssetsCount.unmapped_count);
        } else {
          const updatedCount = res.fileList.asinAssetsCount.resultcnt[0];

          if (updatedCount) {
            props.setAsinCount((prevCounts) =>
              prevCounts.map((item) =>
                item.asinList === updatedCount.asinList ? updatedCount : item
              )
            );
          }
        }
      }

      setSubmissionNote('');
    };

    return (
        <>
            <Row>
                <Col md={6}>
                    <Card className="ml-4 card-of-problemarea p-3 graphics-tab-fixed-images-card-height">
                        <div className="d-flex align-items-center justify-content-between w-100">
                            <div className="d-flex align-items-center">
                                <input
                                    type="checkbox"
                                    id="selectAll"
                                    checked={selectAllImages}
                                    onChange={handleSelectAllImages}
                                />
                                <label htmlFor="selectAll" className="mb-0 ml-2">
                                    <b>Select All</b>
                                </label>
                            </div>
                            <div className="d-flex align-items-center w-50 justify-content-end">
                                <Input
                                    type="text"
                                    placeholder="Search"
                                    className="w-100"
                                    value={imageSearchText}
                                    onChange={(e) => setImageSearchText(e.target.value)}
                                />
                            </div>
                        </div>
                        <Row className="image-scroll-container mt-3">
                        {searchedImages && searchedImages.length > 0 ? (
                                searchedImages.map((img, index) => (
                                    <Col md={4} key={index}>
                                        <Card className="p-2 text-center submissions-image-wrapper position-relative">
                                            <button
                                                onClick={() => submissionsChats(img)}
                                                className="btn p-0 images-note-icon"
                                            >
                                                <img
                                                    src={CommentIcon}
                                                    alt="Comment"
                                                    height={16}
                                                    width={16}
                                                    title="Notes"
                                                />
                                            </button>
                                            <img
                                                src={img.filePath}
                                                alt={img.actualFileName}
                                                className="submissions-image-box"

                                            />
                                            <input
                                                type="checkbox"
                                                className="form-check-input submissions-checkbox"
                                                checked={selectedImages.includes(img.id)}
                                                onChange={() => handleImageCheckboxChange(img.id)}
                                            />
                                            <div className="d-flex justify-content-between">
                                                <small><b style={{ paddingLeft: '45px' }}>{img.id}</b></small>
                                                <small><b style={{ color: '#B01A00' }}>#{img.amazonPosition || ''}</b></small>
                                            </div>
                                        </Card>
                                    </Col>
                                ))
                            ) : (
                                <Col md={12} className="text-center text-muted mt-5">
                                    <p>No images available.</p>
                                </Col>
                            )}
                        </Row>
                    </Card>
                </Col>
                <Col md={6} className="mt-4">
                    <label><h6><b>Note : </b></h6></label>
                    <ReactQuill
                        theme={'snow'}
                        value={sumbmissionNote}
                        modules={Editor.modules}
                        formats={Editor.formats}
                        onChange={handleQuillChange}
                        bounds={'.quill-prod'}
                        placeholder='Add your comments here'
                    />
                </Col>
            </Row>
            <Col md={12} className="mt-4 mb-2">
                <div className="d-flex justify-content-center">
                    <Button
                        className="btn-background-color mr-5"
                        style={{ width: '300px' }}
                        onClick={() => setConfrimationForSubmition(true)}
                        disabled={selectedImages.length === 0}

                    >
                        Send Graphics for Approval
                    </Button>
                </div>
            </Col>
            <CustomModal
                isOpen={isCommentsPopUpOPen}
                toggle={() => setIsCommentsPopUpOPen(false)}
                size="xl"
                header={<p title={selectedFileObject.actualFileName} className="comment-paragraph-Project-asin-title">{selectedFileObject.actualFileName}</p>}
                className="curve-popup "
            >
                <LoadingOverlay
                    active={loadScreen}
                    styles={{
                        overlay: (base) => ({
                            ...base,
                            background: '#f1f4f6',
                            opacity: 1,
                        }),
                        content: (base) => ({
                            ...base,
                            color: '#000',
                        }),
                    }}
                    spinner={<Loader active type="ball-pulse" />}
                    text="Loading chat details..."
                >
                    <AssetsCommentsPopup
                        filePath={filePath}
                        demoImage={demoImage}
                        noteList={noteList}
                        setNote={setComment}
                        note={comment}
                        action={false}
                        selectedFileObject={selectedFileObject}
                        addCMAssetChats={addSubmissionsChats}
                    />
                </LoadingOverlay>
            </CustomModal>
            <SendAssetsApprovalPopup
                isOpen={confrimationForSubmition}
                toggle={() => setConfrimationForSubmition(false)}
                mode="graphics"
                selectedAssetIds={selectedImages}
                fileList={filteredImages}
                filterSubcategoryList={props.filterSubcategoryList}
                filterProductSubcategoryList={props.filterProductSubcategoryList}
                selectedProjectData={props.selectedProjectData}
                selectedSubCategories={props.selectedSubCategories}
                selectedASIN={props.selectedASIN}
                submissionNote={sumbmissionNote}
                submissionName={
                    props.selectedASIN ? `Graphics_${props.selectedASIN}` : 'Other'
                }
                headerTitle="Send Graphics for Approval"
                token={props.token}
                onSubmitSuccess={handleSubmissionSuccess}
            />
        </>
    )
}

const mapStateToProps = (state) => ({
    token: state.loggedUser.token,
    storeOverview: state.accountOverview.store.storeOverview,

});
export default connect(mapStateToProps)(GraphicsSubmission);